const category = {
  hero: {
    cta: "进入专题",
  },
  subcategorySection: {
    label: "热门子分类",
    title1: "探索更多",
    title2: "吃瓜维度",
    description: "从不同角度切入，全方位追踪娱乐圈最新动态。",
    viewAll: "查看全部",
  },
  hotSection: {
    description: "发掘最劲爆的瓜，追踪最热门的娱乐话题。一手爆料，深度分析。",
  },
  articleListTitle: "全部文章",
  structuredData: {
    webpageDescription: "浏览51吃瓜网分类文章，追踪网红大瓜、黑料爆料、每日大赛等娱乐资讯。",
  },
};

export default category;